import { useAtomValue } from "jotai";

import { sidePanelAtom } from "../side-panel.state";

import SidePanelCloseListener from "./side-panel-close-listener.component";

const SidePanelCloseListenerWrapper = () => {
  const { visible } = useAtomValue(sidePanelAtom);

  return visible ? <SidePanelCloseListener /> : null;
};

export default SidePanelCloseListenerWrapper;
